/* eslint-disable @next/next/no-img-element */
import { PlayerListItemFragment, RefereeListItemFragment } from '@amf/shared/types/graphql';
import Container from '@amf/shared/components/layout/Container';
import React, { ReactNode } from 'react';
import { getInitials } from '@amf/shared/utils/string';
import Link from 'next/link';
import { useTranslate } from '@tolgee/react';
import IconArrowLeft from '@amf/shared/icons/IconArrowLeft';
import Button, { ButtonProps } from '@amf/shared/components/button/Button';

interface Props {
  title: string;
  person: RefereeListItemFragment | PlayerListItemFragment;
  prefixes: { list?: string };
  children: ReactNode;
  buttonProps?: ButtonProps;
}

function PersonHeader({ title, person, prefixes, children, buttonProps }: Props) {
  const { t } = useTranslate();
  return (
    <div className='PersonHeader'>
      <Container className='PersonHeader__container'>
        <div className='PersonHeader__navigation'>
          <h1 className='PersonHeader__title'>{title}</h1>
          {prefixes.list && (
            <Link href={prefixes.list}>
              <a>
                <Button variant='dark-outline' leftIcon={<IconArrowLeft />} {...buttonProps}>
                  {t('person.header.back')}
                </Button>
              </a>
            </Link>
          )}
        </div>
        <div className='PersonHeader__card'>
          <div className='PersonHeader__photo'>
            {person.photoUrl && <img src={person.photoUrl} alt={person.fullName} />}
            {!person.photoUrl && <div>{getInitials(person.givenName, person.familyName)}</div>}
          </div>
          <div className='PersonHeader__content'>
            <h2 className='PersonHeader__fullName'>{person.fullName}</h2>
            <div>
              <p className='PersonHeader__identifier'>{person.amfId}</p>
            </div>
            {children}
          </div>
          <div className='PersonHeader__crosses'>
            <div className='PersonHeader__cross' />
            <div className='PersonHeader__cross' />
            <div className='PersonHeader__cross' />
            <div className='PersonHeader__cross' />
            <div className='PersonHeader__cross' />
          </div>
        </div>
      </Container>
    </div>
  );
}

export default PersonHeader;
